import React from 'react'
import { FormControl } from 'react-bootstrap'

const I = (props) => {
  return (
    <div style={{display:'inline-block'}}>
      {props.label && <label className="labelz" style={{marginBottom:5}}>{props.label}</label>}
      <FormControl {...props} type={props.datatype || 'text'}
        onChange={(e)=>props.onChange(e, e.target.value)}/>
    </div>
  )
}

export default I


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Input.js